const timeoutListeners = new Set();

export const notifyApiTimeout = () => {
  timeoutListeners.forEach((listener) => listener());
};

export const subscribeToApiTimeout = (listener) => {
  timeoutListeners.add(listener);

  return () => {
    timeoutListeners.delete(listener);
  };
};
